import {getRelativeDates} from '../../../../utils/relative-dates';

export function getSavedSearchDates(dateStartValue, dateEndValue, updatedAt, dateRangeType) {
  let dateStart, dateEnd;
  if (dateRangeType) {
    const relativeDates = getRelativeDates(dateStartValue, dateEndValue, updatedAt);
    dateStart = relativeDates.relativeStartDate;
    dateEnd = relativeDates.relativeEndDate;
  } else {
    dateStart = dateStartValue;
    dateEnd = dateEndValue;
  }

  return {
    dateStart,
    dateEnd,
  };
}
